import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-csrsport-new-page',
  templateUrl: './csrsport-new-page.component.html',
  styleUrls: ['./csrsport-new-page.component.css'],
})
export class CsrsportNewPageComponent implements OnInit {
  constructor(private router: Router) {}
  ngOnInit(): void {}
  partnerregister() {
    this.router.navigateByUrl('/partner-register');
  }
}
